export const getStandardSyncerFields = function (commandName, c, returnFields) {
    const mutationName = `${commandName}${c}`;
    const inputKey = `${commandName}Input${c}`;
    const query = `
        ${mutationName}: ${commandName}(input: $${inputKey}) {
            ${returnFields}
        }
    `;
    return { mutationName, inputKey, query };
};
export const syncUpCommandsToMutation = async (commands, mutationName) => {
    const inputPairs = [];
    const mutations = [];
    const parameters = {};
    const validCommands = [];
    await Promise.all(commands.map(async (c) => {
        try {
            parameters[c.inputKey] = typeof c.input === 'function' ? await c.input() : c.input;
            inputPairs.push(`$${c.inputKey}: ${c.inputType}!`);
            mutations.push(c.query);
            validCommands.push(c);
        }
        catch (e) {
            console.error(e);
        }
    }));
    const query = `
            mutation ${mutationName}(
                ${inputPairs.join('\n')}
            ) {
                ${mutations.join('\n')}
            }
        `;
    return { query, parameters, validCommands };
};
//# sourceMappingURL=syncUp.js.map